import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { createFirstAccessibleUrlTree } from '../navigation/sidebar-nav-items';
import { AccessControlService } from '../services/access-control.service';
import { AuthService } from '../services/auth.service';

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const accessControl = inject(AccessControlService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  return accessControl.ensureLoaded().pipe(
    map((loaded) => {
      if (!loaded) {
        return true;
      }
      return createFirstAccessibleUrlTree(router, accessControl);
    }),
  );
};
